import { z } from 'zod';

import { REASON_FIELD_NAME, REASON_MAX_LENGTH } from './consts';

import type { LostDealFormValues } from './types';
import type { TFunction } from 'i18next';

export const createLostDealSchema = (t: TFunction) =>
    z.object({
        reason: z
            .string()
            .trim()
            .max(
                REASON_MAX_LENGTH,
                t('crm.lostDeal.validation.reasonMaxLength', { max: REASON_MAX_LENGTH })
            )
            .min(1, t('crm.lostDeal.validation.reasonRequired')),
    });

export type TLostDealFormInput = z.input<ReturnType<typeof createLostDealSchema>>;
export type TLostDealFormState = z.output<ReturnType<typeof createLostDealSchema>>;

export const defaultFormValues: LostDealFormValues = {
    [REASON_FIELD_NAME]: '',
};
